import React from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import SuperSimulationDetails from "./SuperSimulationDetails";
import SuperSimulations from "./SuperSimulations";

const SuperSimulationsTab: React.FC<RouteComponentProps<{ id: string }>> = (
  props
) => {
  return (
    <div className="mt-6 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <Switch>
        <Route
          path={`${props.match.path}/:simulationUuid/:subsection`}
          component={SuperSimulationDetails}
        />
        <Route path={props.match.path} component={SuperSimulations} />
        <Redirect to={props.match.path} />
      </Switch>
    </div>
  );
};

export default SuperSimulationsTab;
